/* eslint-disable no-unneeded-ternary */
import React, { useState } from 'react'
import { Button } from 'components/UI/'
import { Grid, Modal } from '@material-ui/core/'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import { setChatUser } from '../../../../../../../modules/chatCategory/actions'
import AcceptRequestMessage from '../AcceptMessageRequest'
import RequestChatMessage from '../RequesChatMessage'
import apiChat from '../../../../../../../api/chat'
import DateMeeting from '../../Avtor/DateMeeting'
import MessageAvtor from '../../Avtor/SendAvtorMessage'
import MessageUser from '../../Avtor/SendUserMessage'
import AcceptMeetTime from '../AcceptMeetTime'
import DeclineMeetTime from '../DeclineMeetTime'
import KeepChat from '../KeepChat'
import './index.scss'

const AcceptKeepCaht = ({ open, setOpen }) => (
  <Modal
    open={open}
    onClose={setOpen}
  >
    <div className='acceptKeepChat' onClick={setOpen}>
      <div className='boxKeepModal'>
        <div className='textKeep'>Chat deleted!</div>
        <Button
          className='keepBtnChat'
          onClick={setOpen}
        >
          Ok
        </Button>
      </div>
    </div>
  </Modal>
)

const UserContainer = ({ userMess, setUserMess, setText, text, deleteId, setDeleteId, updateMessage, setValue, setEditTextMess }) => {
  const { chatUser, isMobile } = useSelector(({ chat }) => chat)
  const { user } = useSelector(({ session }) => session)
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  const userName = id => {
    if (id === chatUser?.users?.[0]?.uuid) {
      return chatUser?.users?.[0]?.name
    } else if (id === chatUser?.users?.[1]?.uuid) {
      return chatUser?.users?.[1]?.name
    }
  }

  const acceptDeclineChat = type => {
    if (type === 'decline') {
      apiChat.acceptChatUser(user?.accessKey, chatUser?.uuid, type)
        .then(() => {})
      setUserMess([])
      dispatch(setChatUser({}))
    } else {
      apiChat.acceptChatUser(user?.accessKey, chatUser?.uuid, type)
    }
  }

  const avtorName = id => {
    if (id === chatUser?.users?.[0]?.uuid) {
      return chatUser?.users?.[0]?.name
    } else if (id === chatUser?.users?.[1]?.uuid) {
      return chatUser?.users?.[1]?.name
    }
  }

  const setIdHandler = id => {
    if (id !== deleteId) {
      setDeleteId(id)
    } else if (deleteId) {
      setDeleteId('')
    } else {
      setDeleteId(id)
    }
  }

  const deleteMessage = () => {
    apiChat.deleteMessage(user?.accessKey, deleteId)
      .then(() => {
        setDeleteId('')
      })
  }

  const keepChat = () => {
    apiChat.keepChat(user?.accessKey, chatUser?.uuid)
  }

  const deleteChat = () => {
    apiChat.deleteChat(user?.accessKey, chatUser?.uuid)
      .then(() => setOpen(true))
  }

  const editMessage = (data, id) => {
    setText(id)
    setEditTextMess(data)
  }

  const keepChatDelete = () => {
    apiChat.keepChatDelete(user?.accessKey, chatUser?.uuid)
      .then(() => setOpen(true))
  }

  return (
    <>
      <AcceptKeepCaht open={open} setOpen={() => setOpen(false)} />
      {userMess?.map(i => (
        i?.from !== user?.user?.uuid ? (
          i?.chatStatus === 'request' ? (
            i?.type === 'chat_request' && (
              +userMess?.length === 1 ? (
                <Grid className='requestChatWrapperBack'>
                  <RequestChatMessage
                    acceptDeclineChat={acceptDeclineChat}
                    noBtn={userMess?.length}
                    name={userName(i?.from)}
                    text={i?.text}
                  />
                </Grid>
              ) : +userMess?.length > 1 ? (
                <RequestChatMessage
                  acceptDeclineChat={acceptDeclineChat}
                  noBtn={userMess?.length}
                  name={userName(i?.from)}
                  text={i?.text}
                />
              ) : null
            )
          ) : i?.meetingStatus === 'requested' ? (
            i?.type === 'meeting' ? (
              <DateMeeting
                newTitle
                date={moment(+i?.meetingStart)?.format('MMMM D')}
                time={`${moment(+i?.meetingStart)?.format('LT')} (${moment(+i?.meetingStart)?.format('Z')})`}
                name={userName(i?.from)}
                noAvtor
                isMobile={isMobile}
              />
            ) : null
          ) : i?.type === 'text' ? (
            <MessageUser
              name={avtorName(i?.from)?.charAt(0)}
              time={moment(+i?.time)?.format('LT')}
              text={i?.text}
              id={i?.uuid}
              deleteId={deleteId}
              setIdHandler={setIdHandler}
              onDeleteMeesage={deleteMessage}
            />
          ) : i?.type === 'chat_review' ? (
            !i?.keep && (
              <KeepChat keepChat={keepChat} deleteChat={keepChatDelete} name={avtorName(i?.from)} />
            )
          ) : null
        ) : i?.from === user?.user?.uuid ? (
          i?.chatStatus === 'meeting' ? (
            i?.type === 'chat_request' && (
              <AcceptRequestMessage newContent={userMess?.length} isMobile={isMobile} />
            )
          ) : i?.type === 'text' ? (
            <MessageAvtor
              key={i?.uuid}
              name={avtorName(i?.from)?.charAt(0)}
              time={moment(+i?.time)?.format('LT')}
              read={i?.status === 'sended' ? false : true}
              text={i?.text}
              id={i?.uuid}
              deleteId={deleteId}
              setIdHandler={setIdHandler}
              onDeleteMeesage={deleteMessage}
              updateMessage={editMessage}
              setText={setText}
            />
          ) : i?.meetingStatus === 'declined' ? (
            i?.type === 'meeting' ? (
              <DeclineMeetTime />
            ) : null
          ) : i?.meetingStatus === 'accepted' ? (
            i?.type === 'meeting' && (
              <AcceptMeetTime date={`${moment(+i?.meetingStart)?.format('dddd, MMMM D')} at ${moment(+i?.meetingStart)?.format('LT')}`} />
            )
          ) : null
        ) : null
      ))}
    </>
  )
}

export default UserContainer
